import {
  LOC_FOUND,
  LOC_DENIED,
  SAVE_SELECTED_SERVICES,
  BOOK_APPOINTMENT,
  FIND_AVAILABLE_SLOTS,
  ACTIVATE_SALON,
  DEACTIVATE_SALON,
  SUBMIT_FEEDBACK,
  POST_UID,
  ADD_USER_ADDRESS,
  GET_USER_ADDRESS,
  DEACTIVATE_USER_ADDRESS,
  UPDATE_USER_ADDRESS,
} from "../constants";

export const getLocationSuccess = () => ({
  type: LOC_FOUND,
});

export const getLocationDenied = () => ({
  type: LOC_DENIED,
});

export const saveSelectedService = ({ selectedServices }) => ({
  type: SAVE_SELECTED_SERVICES,
  selectedServices,
});

export const bookAppointment = ({ payload }) => ({
  type: BOOK_APPOINTMENT,
  payload,
});

export const findAvailableSlots = ({ payload }) => ({
  type: FIND_AVAILABLE_SLOTS,
  payload,
});

export const activateSalon = () => ({
  type: ACTIVATE_SALON,
});

export const deActivateSalon = () => ({
  type: DEACTIVATE_SALON,
});

export const submitFeedback = (payload) => ({
  type: SUBMIT_FEEDBACK,
  payload,
});

export const postUid = (payload) => ({
  type: POST_UID,
  payload,
});

export const addUserAddress = (payload) => ({
  type: ADD_USER_ADDRESS,
  payload,
});

export const getUserAddress = (payload) => ({
  type: GET_USER_ADDRESS,
  payload,
});

export const deactivateUserAddress = (payload) => ({
  type: DEACTIVATE_USER_ADDRESS,
  payload,
});

export const updateUserAddress = (payload) => ({
  type: UPDATE_USER_ADDRESS,
  payload,
});
